import React, { createContext } from 'react';

export const TradingContext = createContext();

const TradingContextProvider = ({ children, selectedLevels, setSelectedLevels }) => {
  return (
    <TradingContext.Provider value={{ selectedLevels, setSelectedLevels }}>
      {children}
    </TradingContext.Provider>
  );
};

export default TradingContextProvider;